export const enum ScanMode {
  // 0:代表スキャン、
  REPRESENTATIVE_SCAN = 0,
  // 1:全数スキャン
  ONE_HUNDRED_PERCENT_SCAN = 1
}
